import { IContent } from './content';
import { IPageOption } from './ui';

export interface ICollection {
  id: number;
  organizationId: number | null;
  name: string;
  title: string;
  subTitle: string;
  type: CollectionType;
  contents: (IContent | number)[];
  createdAt: string;
  updatedAt: string;
  contentSortOrder?: {
    contentId: number;
    sortOrder: number;
  }[];
}

export enum CollectionType {
  MAIN_BANNER = 'MAIN_BANNER',
  SINGLE_BANNER = 'SINGLE_BANNER',
  GRID = 'GRID',
  CARD = 'CARD',
  DEFAULT = 'DEFAULT',
}

export type SearchCollectionsFilterType = Partial<Pick<ICollection, 'title'>>;
export type SearchCollectionsQueryType = IPageOption &
  Partial<Pick<ICollection, 'title'>>;
